<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-08-01 14:28:13
 * @LastEditTime: 2024-09-05 17:33:33
 * @LastEditors:  
-->
<template>
  <div class="mobile-container">
    <page-header>{{content.pageTitle | dealLanguage(content.enPageTitle)}}</page-header>
    <div class="mobile-content" v-html="content.content" v-if="language == 'zh'"></div>
    <div class="mobile-content" v-html="content.enContent" v-if="language == 'en'"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/mobile/pageHeader.vue'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? this.content.pageTitle : this.content.enPageTitle, 
    }
  },
  inject: ['wxShare'],
  data() {
    return {
      // id: 1,
      content: '',
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      contentNav: (state) => state.contentNav,
      mainPageContent: (state) => state.mainPageContent,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
    }),
    id() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.getMainPageContent()
  },
  watch: {
    id: function (val) {
      this.getMainPageContent()
    },
  },
  methods: {
    getMainPageContent() {
      const arr = [...this.mainPageContent, ...this.contentNav]
      const item = arr.find((a) => a.id == this.$route.params.id) || {}
      this.content = { ...item }
      if (!this.content.id) return
      this.content.content = this.content.content.replace(/preload="none"/g, 'preload="auto"')

      this.wxShare({
        title: filter.dealLanguage(`${this.content.pageTitle}-2025VB100大会`, `${this.content.enPageTitle}-2025VB100 Conference`),
        linkurl: this.vbef_path + '/exhibitionDesc/' + this.$route.params.id,
        
      })

      // let res = await getMainPageContent({
      //   activityId: this.activityId
      // })
      // if(res.code == 0) {
      //   if(res.data.mainPageContentRelationDtos.length > 0) {
      //     this.content = res.data.mainPageContentRelationDtos.filter(item => item.id == this.id)[0]
      //   }
      // }
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  >>> .mobile-content
    padding 0.2rem 0.4rem
    overflow hidden
    width 100%
    font-size 0.34rem
    color #1D2129
    line-height 0.62rem
    text-align justify
    letter-spacing 0.002rem
    font-weight 300
    ol
      list-style auto
      padding-left 0.2rem
      li
        list-style auto
    ul
      list-style disc
      padding-left 0.2rem
      li
        list-style disc
    img
      margin 0 auto
      display block
      width 100% !important
      height auto !important
    span
      max-width 100% !important
      padding 0
    p, div
      max-width 100% !important
      margin 0
      font-size 0.34rem
      font-weight 500
      color #1D2129
      line-height 0.62rem
      text-align justify
      letter-spacing 0.002rem
      font-weight 300
      word-wrap break-word
      word-break normal
    table
      width 100%
    table
      td
        border 1px solid #e5e5e5
    iframe
      width 100% !important
      height 4rem !important
    section
      max-width 100% !important
      p
        margin inherit
        font-size inherit
        font-weight inherit
        color inherit
        line-height inherit
        text-align inherit
    video
      max-width 100% !important
      max-height 8rem !important
      background #000
    .toastui-editor-ww-code-block-highlighting
      overflow auto
      max-width 100% !important
</style>